import React, { useState } from 'react'
import clsx from 'clsx'
import Image from 'next/image'
import ProductPlaceholderIcon from '@ancon/wildcat-ui/shared/static/placeholders/product-v2.svg'
import { MediaEntityType } from '@ancon/wildcat-types'

import isDefaultProductCardStyle from '../utils/isDefaultProductCardStyle'
import OptimizedImage from '../../app/components/OptmizedImage'
import useAppSelector from '../../../store/hooks/useAppSelector'
import { outletSelectedOutletListItemTenantIdSelector } from '../../outlet/store/outletSelector'

import styles from './ProductCardBanner.module.scss'
import ProductImageLoadingSpinner from './ProductImageLoadingSpinner'

export type ProductCardBannerProps = {
  productId: string
  productName: string | null
  productImageId?: string | null
  disabled?: boolean
}

export default function ProductCardBanner({
  productId,
  productName,
  productImageId,
  disabled = false,
}: ProductCardBannerProps) {
  const [isLoading, setIsLoading] = useState(!!productImageId)

  const defaultProductCardStyle = isDefaultProductCardStyle()

  const tenantId = useAppSelector(outletSelectedOutletListItemTenantIdSelector)

  return (
    <div
      className={clsx(styles.container, {
        [styles.imageOnTopStyle]: !defaultProductCardStyle,
        [styles.disabled]: disabled,
      })}
    >
      {(!defaultProductCardStyle || productImageId) && (
        <div className={styles.imageContainer}>
          {isLoading && <ProductImageLoadingSpinner />}
          {productImageId && (
            <OptimizedImage
              mediaId={productImageId}
              tenantId={tenantId!}
              mediaEntityId={productId}
              mediaEntityType={MediaEntityType.Product}
              src={productImageId}
              className={styles.bannerImage}
              fill={!defaultProductCardStyle}
              alt={productName || 'product image'}
              width={defaultProductCardStyle ? 140 : undefined}
              height={defaultProductCardStyle ? 120 : undefined}
              onLoadStart={() => {
                setIsLoading(true)
              }}
              onLoad={() => setIsLoading(false)}
            />
          )}
          {!defaultProductCardStyle && !productImageId && (
            <Image
              alt={productName || 'product placeholder image'}
              className={styles.placeholderImage}
              src={ProductPlaceholderIcon}
            />
          )}
        </div>
      )}
    </div>
  )
}
